export { ErrorHero } from "./main";
